module.exports = __webpack_public_path__ + "img/7.552bd778.jpg";